import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Icon, UilChartPie } from '@iconscout/react-unicons';

export interface Route {
  name: string;
  icon?: IconProp | string | string[];
  iconSet?: 'font-awesome' | 'feather' | 'unicons';
  pages?: Route[];
  path?: string;
  pathName?: string;
  flat?: boolean;
  topNavIcon?: string;
  dropdownInside?: boolean;
  active?: boolean;
  new?: boolean;
  hasNew?: boolean;
}

export interface RouteItems {
  label: string;
  horizontalNavLabel?: string;
  icon: Icon;
  labelDisabled?: boolean;
  pages: Route[];
  megaMenu?: boolean;
  active?: boolean;
}

export const routes: RouteItems[] = [
  {
    label: 'dashboard',
    horizontalNavLabel: 'home',
    active: true,
    icon: UilChartPie,
    labelDisabled: false,
    pages: [
      {
        name: 'dashboard',
        path: '/dashboard',
        pathName: 'dashboard',
        active: true
      },
      {
        name: 'users',
        path: '/users',
        pathName: 'users',
        active: true
      },
      {
        name: 'normal-points-reward',
        path: '/normal-points-reward',
        pathName: 'normal-points-reward',
        active: true
      },
      {
        name: 'referral-points-reward',
        path: '/referral-points-reward',
        pathName: 'referral-points-reward',
        active: true
      }
    ]
  },
  {
    label: 'Reward Rules',
    horizontalNavLabel: 'Reward Rules',
    active: true,
    icon: UilChartPie,
    labelDisabled: false,
    pages: [
      {
        name: 'drink',
        path: '/reward-rules/drink',
        pathName: 'reward-drink-list',
        active: true
      },
      {
        name: 'challenge',
        path: '/reward-rules/challenge',
        pathName: 'reward-challenge-list',
        active: true
      }
    ]
  },
  {
    label: 'Claim request',
    horizontalNavLabel: 'Claim request',
    active: true,
    icon: UilChartPie,
    labelDisabled: false,
    pages: [
      {
        name: 'normal',
        path: '/claim-request/normal',
        pathName: 'claim-normal-list',
        active: true
      },
      {
        name: 'referral',
        path: '/claim-request/referral',
        pathName: 'claim-referral-list',
        active: true
      }
    ]
  },
  {
    label: 'Claim Transactions',
    horizontalNavLabel: 'Claim Transactions',
    active: true,
    icon: UilChartPie,
    labelDisabled: false,
    pages: [
      {
        name: 'reward-claim',
        path: '/reward-claim',
        pathName: 'reward-claim-list',
        active: true
      }
    ]
  },
  {
    label: 'FeePayer wallet',
    horizontalNavLabel: 'FeePayer wallet',
    active: true,
    icon: UilChartPie,
    labelDisabled: false,
    pages: [
      {
        name: 'All',
        path: '/feepayer-wallet/list',
        pathName: 'privy-wallet-list',
        active: true
      },
      {
        name: 'Generate',
        path: '/feepayer-wallet/generate',
        pathName: 'privy-wallet-generate',
        active: true
      },
      {
        name: 'Active',
        path: '/feepayer-wallet/details',
        pathName: 'privy-wallet-details',
        active: true
      }
    ]
  },
  // {
  //   label: 'Flywheel wallet (Believe)',
  //   horizontalNavLabel: 'Flywheel wallet (Believe)',
  //   active: true,
  //   icon: UilChartPie,
  //   labelDisabled: false,
  //   pages: [
  //     {
  //       name: 'Flywheel Wallet',
  //       path: '/flywheel-wallet',
  //       pathName: 'flywheel-wallet',
  //       active: true
  //     }
  //   ]
  // },
  {
    label: 'Investor Airdrop',
    horizontalNavLabel: 'Investor Airdrop',
    active: true,
    icon: UilChartPie,
    labelDisabled: false,
    pages: [
      {
        name: 'Airdrop USDC',
        path: '/investor-airdrop',
        pathName: 'investor-airdrop',
        active: true
      }
    ]
  },
  {
    label: 'Settings',
    horizontalNavLabel: 'Settings',
    active: true,
    icon: UilChartPie,
    labelDisabled: false,
    pages: [
      {
        name: 'Public',
        path: '/settings/public',
        pathName: 'public-settings',
        active: true
      },
      {
        name: 'Private',
        path: '/settings/private',
        pathName: 'private-settings',
        active: true
      }
    ]
  }
  // {
  //   label: 'My Account',
  //   horizontalNavLabel: 'My Account',
  //   active: true,
  //   icon: UilChartPie,
  //   labelDisabled: false,
  //   pages: [
  //     {
  //       name: 'Profile',
  //       path: '/profile',
  //       pathName: 'profile',
  //       active: true
  //     }
  //   ]
  // }
];
